"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalespersonSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
const enums_1 = require("../enums");
exports.SalespersonSchema = base_1.BaseSchema.extend({
    handle: base_1.ShortStringSchema,
    name: base_1.ShortStringSchema,
    storefrontPreferences: zod_1.z.object({ itemsVisibility: zod_1.z.nativeEnum(enums_1.StorefrontItemsVisibility) }),
    storeId: base_1.ShortStringSchema.uuid(),
    associatedUserId: base_1.ShortStringSchema.uuid().optional(),
    email: base_1.ShortStringSchema.email().optional(),
    profileImageUri: base_1.LongStringSchema.url().optional(),
    whatsAppNumber: base_1.PhoneSchema.optional(),
    itemIds: zod_1.z.array(base_1.ShortStringSchema.uuid()).optional(),
});
//# sourceMappingURL=index.js.map